/**
 * 学習パラメータとスコアを保持するクラス
 */
export default class TrainParams {
    /**
     * 生データ\
     * 最後に作成完了したWLモデルの学習パラメータとスコア取得APIのレスポンスを想定しています。
     */
    private _rawData: any[];

    /**
     * スコアとして使用するデータのキー
     */
    private _ScoreHeaders: string[] = ['fvalue', 'precision', 'recall'];

    /**
     * パラメータとして表示しないデータのキー
     */
    private _hiddenParamsHeaders: string[] = ['penalty', 'C'];

    /**
     * 生データのヘッダー
     */
    private _headers: string[] = [];

    /**
     * 生データの値（ヘッダー以外のデータ）
     */
    private _values: any[] = [];

    /**
     * パラメータ一覧
     */
    public params: { [key: string]: number[] } = {};

    /**
     * スコア一覧
     */
    public scores: { [key: string]: number[] } = {};

    /**
     * ベストなデータのindex
     */
    private _bestValueIndex: number | undefined;

    /**
     * ベストパラメータ
     */
    public bestParams: { [key: string]: number } = {};

    /**
     * ベストスコア
     */
    public bestScores: { [key: string]: number } = {};

    /**
     * コンストラクタ
     * @param rawData 生データ
     */
    constructor(rawData: any[]) {
        this._rawData = rawData;
        this._headers = rawData.slice(0, 1)[0];
        this._values = rawData.slice(1);

        this._separateParamsAndScores();
        this._setBestValue();
    }

    /**
     * ベストスコア(fvalueが最高)のデータを計算して保持
     */
    private _setBestValue(): void {
        // fvalue が最大となるデータ行を決定
        let index = 0;
        let currentMaxFvalue = 0;
        for (let i = 0; i < this.scores['fvalue'].length; i++) {
            const fvalue = this.scores['fvalue'][i];
            if (fvalue > currentMaxFvalue) {
                index = i;
                currentMaxFvalue = fvalue;
            }
        }
        this._bestValueIndex = index;

        // ベストスコアのデータを取得し、パラメータとスコアのデータに分ける
        for (let i = 0; i < this._headers.length; i++) {
            const header: string = this._headers[i];
            const isScore = this._ScoreHeaders.includes(header);
            const val = this._values[index][i];

            // 非表示ヘッダーに指定されていれば追加処理は行わない
            if (this._hiddenParamsHeaders.includes(header)) {
                continue;
            }

            if (isScore) {
                this.bestScores[header] = val;
            } else {
                this.bestParams[header] = val;
            }
        }
    }

    /**
     * APIからのレスポンスから、パラメータとスコアのデータに分ける
     */
    private _separateParamsAndScores(): void {
        for (let i = 0; i < this._headers.length; i++) {
            const header = this._headers[i];
            const isScore = this._ScoreHeaders.includes(header);
            const vals = this._values.map(row => row[i]);

            if (isScore) {
                this.scores[header] = vals;
            } else {
                this.params[header] = vals;
            }
        }
    }
}
